<template>
  <div class="file-viewer-image-large-wrapper" :class="{ maximized }">
    <swiper
      ref="imageSwiper"
      :options="imageSwiperOptions"
      class="image-swiper"
      @wheel.native.stop.prevent
      @click="maximize"
    >
      <swiper-slide>
        <div class="image-wrapper">
          <img :src="viewFile" />
        </div>
      </swiper-slide>
    </swiper>
    <div v-if="maximized" class="restore-button" @click="restore">
      <i class="iconfont icon-guanbianniu"></i>
    </div>
    <span v-else class="label">长图</span>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    viewFile: {
      type: String,
      default: ''
    },
    maximized: Boolean
  },
  data() {
    return {
      imageSwiperOptions: {
        direction: 'vertical',
        freeMode: true,
        slidesPerView: 'auto',
        mousewheel: true,
        observer: true,
        observeParents: true
      }
    }
  },
  methods: {
    maximize() {
      this.$emit('maximize')
    },
    restore() {
      this.$emit('restore')
    }
  }
}
</script>

<style lang="scss" scoped>
.file-viewer-image-large-wrapper {
  height: 100%;
  background-color: #000000;
  position: relative;
  .swiper-slide {
    width: auto;
    height: auto;
  }
  .image-swiper {
    height: 100%;
  }
  .image-wrapper {
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    img {
      max-width: 100%;
    }
  }
  .label {
    position: absolute;
    height: 30px;
    line-height: 30px;
    left: 24px;
    top: 12px;
    padding: 0 12px;
    font-size: 14px;
    background-color: #3352fe;
    color: #ffffff;
    border-radius: 3px;
  }
  .restore-button {
    position: absolute;
    top: 32px;
    right: 32px;
    width: 56px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    color: #363636;
    background-color: rgba(142, 144, 145, 0.85);
    z-index: 10;
    cursor: pointer;
    i {
      font-size: 35px;
    }
    &:hover {
      background-color: #3352fe;
      color: #ffffff;
    }
  }
  &.maximized {
    .image-wrapper {
      max-width: 58%;
    }
  }
  .download-btn {
    width: 40px;
    height: 40px;
    background-color: rgba(54, 54, 54, 0.85);
    color: #ffffff;
    border: none;
    outline: none;
    margin-right: 20px;
    border-radius: 0;
    cursor: pointer;
    position: absolute;
    bottom: 12px;
    right: 24px;
    z-index: 10;
    &:hover {
      background-color: #3352fe;
    }
    i {
      font-size: 20px;
    }
  }
}
</style>
